import React from "react";
import { Button, Row, Col } from "antd";
import LOCALIZATION from "services/LocalizationService";

function CreateUserSignUpMessage({ status, onBack }) {
  const isSuccess = status === "success";

  const title = isSuccess
    ? LOCALIZATION.SUCCESS_TITLE || "Success"
    : LOCALIZATION.ERROR_TITLE || "Error";

  const message = isSuccess
    ? LOCALIZATION.USER_SIGN_UP.SUCCESS_MESSAGE
    : LOCALIZATION.USER_SIGN_UP.ERROR_MESSAGE;

  return (
    <>
      <section id="create-user-signup">
        <h1 className="title">{title}</h1>
      </section>
      <hr className="signup-separator" />
      <div className={`signup-message ${status}`}>
        <p>{message}</p>

        {!isSuccess && (
          <Row
            className="d-flex justify-end mt-auto form-actions"
            gutter={[16, { xs: 8, xl: 0 }]}
          >
            <Col>
              <Button type="primary" onClick={onBack} size="large">
                {LOCALIZATION.BACK}
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}

export default CreateUserSignUpMessage;
